<template>
  <div
    class="warpfileview"
    id="uploadfileview"
    :class="showdrapdiv ? 'showtishi' : ''"
  >
    <div style="position: relative">
      <span style="font-weight: bold; margin-right: 20px">{{
        filetype.name
      }}</span>
      <div style="display: inline-block">
        <el-button
          v-if="choostotal > 0"
          type="warning"
          size="small"
          plain
          @click="deleteFile()"
          >批量删除</el-button
        >
      </div>
      <div class="searchinputwarp">
        <span>搜索</span>
        <el-input size="large" v-model="searchtext" placeholder="请输入内容"></el-input>
      </div>
    </div>
    <div style="position: relative">
      <el-table
        :data="fileListShow"
        size="small"
        height="calc(100vh - 200px)"
        @selection-change="handleSelectionChange"
        style="width: 98%"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="文件名"> </el-table-column>
        <el-table-column prop="type" label="分类" width="120">
          <template #default="scope">
            <span>{{ filetypeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="time" width="160" label="上传时间">
          <template #default="scope">
            <span>{{ timeformatter(scope.row.first_created) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="size" width="100" label="大小">
          <template #default="scope">
            <span>{{ transformByte(scope.row.size) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="save" width="160" label="存储">
          <template #default="scope">
            <el-tag v-if="scope.row.lan_exists === true">内网</el-tag>
            <el-tag v-if="scope.row.wan_exists === true">外网</el-tag>
            <!--            <el-tag style="cursor:pointer" type="success" v-if="scope.row.wan_exists === false">同步到外网</el-tag>-->
          </template>
        </el-table-column>
        <el-table-column width="160" label="操作">
          <template #default="scope">
            <el-button
              size="small"
              plain
              type="primary"
              @click="downloadFile(scope.row.id)"
              style="margin: 2px 4px"
            >
              <i class="iconfont icon-download"></i>
            </el-button>
            <el-button
              size="small"
              plain
              type="primary"
              @click="shareOpen(scope.row)"
              style="margin: 2px 4px"
            >
              <i class="iconfont icon-share-nodes"></i>
            </el-button>
            <el-button
              size="small"
              plain
              type="danger"
              @click="deleteFile([scope.row.id])"
              style="margin: 2px 4px"
            >
              <i class="iconfont icon-trash-can"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="filenum">
      <span>共{{ total }}个文件，当前选中{{ choostotal }}个</span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineExpose, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import {
  apiResoueceDownload,
  apiResoueceList,
  apiResourceRemove,
} from "@/Api/AppApi";

const props = defineProps(["filetype"]);
defineExpose({ showDarg, hideDrag, loadFileList });

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;
const $confirm = appContext.config.globalProperties.$confirm;
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);

const router = useRouter();

const showdrapdiv = ref(false);
function showDarg() {
  showdrapdiv.value = true;
}
function hideDrag() {
  showdrapdiv.value = false;
}

const choostotal = ref(0);
let multipleSelection = [];
function handleSelectionChange(val) {
  multipleSelection = val;
  choostotal.value = multipleSelection.length;
}

const searchtext = ref("");
watch(searchtext, () => {
  filterList();
});

let fileListData = [];
const fileListShow = ref([]);
function filterList() {
  fileListShow.value = fileListData.filter(
    (data) =>
      !searchtext.value ||
      data.name.toLowerCase().includes(searchtext.value.toLowerCase())
  );
}

const filetypeMap = {
  compressFile: "压缩包",
  app: "安装包",
  video: "视频",
  audio: "音频",
  other: "其他",
};
function timeformatter(val) {
  return $moment(val).format("YYYY-MM-DD HH:mm:ss");
}
function transformByte(val) {
  if (val < 1024) {
    return val.toFixed(0) + " bytes";
  } else if (val < 1024 * 1024) {
    return (val / 1024.0).toFixed(0) + " KB";
  } else if (val < 1024 * 1024 * 1024) {
    return (val / 1024.0 / 1024.0).toFixed(1) + " MB";
  } else {
    return (val / 1024.0 / 1024.0 / 1024.0).toFixed(1) + " GB";
  }
}

const total = ref(0);
const loading = ref(false)
async function loadFileList() {
  searchtext.value = "";
  const params = {
    project_id: currentProjectId.value,
    type: props.filetype.value,
  };
  loading.value = true;
  const res = await apiResoueceList(params);
  loading.value = false;
  if (res.code === 0) {
    fileListData = res.data;
    total.value = fileListData.length;
    filterList();
  }
}

async function downloadFile(id) {
  const postData = {
    id: [id],
  };
  const res = await apiResoueceDownload(postData);
  if (res.code === 0) {
    window.open(res.data[0].url);
  }
}

function shareOpen(row) {
  window.open(router.resolve("/file/").href + row.id, "_blank");
}

async function deleteFile(ids) {
  if (ids === undefined) {
    ids = [];
    for (let i = 0; i < multipleSelection.length; i++) {
      const fileItem = multipleSelection[i];
      ids.push(fileItem.id);
    }
  }
  try {
    await $confirm("是否确定删除该文件?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    const postData = {
      id: ids,
    };
    const res = await apiResourceRemove(postData);
    if (res.code === 0) {
      $message.success("删除成功");
      loadFileList();
    }
  } catch (e) {
    $message({
      type: "info",
      message: "已取消删除",
    });
  }
}
</script>

<style lang="scss" scoped>
.warpfileview {
  margin-left: 10px;
  margin-right: 10px;
  position: relative;
  font-size: 14px;
  line-height: 60px;
  height: 100%;
}
.searchinputwarp {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  span {
    display: inline-block;
    width: 46px;
    height: 60px;
  }
}

.filenum {
  position: absolute;
  top: calc(100vh - 145px);
  font-size: 12px;
  color: #3fbbff;
}

.showtishi {
  &:before {
    content: "上传文件到Tako";
    position: absolute;
    font-size: 50px;
    color: #9f9898;
    z-index: 100;
    background: rgba(255, 255, 255, 0.8);
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
